import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registra o Service Worker (PWA) — só em produção e em ambientes seguros (HTTPS)
// IMPORTANTE: registrar SOMENTE quando o usuário está na área do cliente (/cliente)
// ou na raiz (landing). NÃO registrar globalmente porque o scope '/' fazia o SW
// capturar a área /admin e servir versões cacheadas → tela preta em produção.
if ('serviceWorker' in navigator && (window.location.protocol === 'https:' || window.location.hostname === 'localhost')) {
  window.addEventListener('load', () => {
    const path = window.location.pathname || '/';
    const isAdmin = path.startsWith('/admin');

    if (isAdmin) {
      // Limpa qualquer SW antigo de scope global ('/') que esteja capturando /admin.
      // A área admin tem o próprio SW (registrado pelo hook useAdminPwa) com escopo /admin.
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((r) => {
          const url = (r.active && r.active.scriptURL) || '';
          // Remove o SW antigo do cliente (registrado no escopo global) que está
          // interferindo no /admin. O do admin (admin-service-worker.js) é preservado.
          if (url.endsWith('/service-worker.js')) {
            r.unregister().catch(() => {});
          }
        });
      }).catch(() => {});
      return;
    }

    // Caminho normal (cliente): registra o SW do cliente com escopo /cliente
    // para não interferir com /admin no futuro.
    navigator.serviceWorker.register('/service-worker.js', { scope: '/cliente' })
      .then((reg) => {
        if (reg.waiting) {
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              installing.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch((err) => console.warn('SW registration failed', err));
  });
}
/* FORCE UPDATE 1759476235 */
